import { Component, OnInit, HostListener, Input, ViewChild, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-drawer',
  templateUrl: './drawer.component.html',
  styleUrls: ['./drawer.component.scss']
})
export class DrawerComponent implements OnInit {

  constructor() { }

  @Input() isModal = false;
  @Input() drawerId: string;
  @Input() width?: any;  // if width === 'half' then show drawer on half of page in size otherwise full in size.
  @Input() detailDrawer = false;
  @Input() bankSelectionDrawer = false;
  @Input() consentDetailsDrawer = false;
  @Output() backdrop = new EventEmitter<any>();
  public openDrawer = false;
  @Input() infoDrawer = false;

  ngOnInit() {
  }
  /*** Opens up the drawer */
  public open() {
    this.openDrawer = true;
  }

  /*** Closes the drawer */
  public close() {
    this.openDrawer = false;
  }

 /*** Click on the overlay*/
  public showHideDrawer() {
    if (this.isModal) {
      console.log(this.backdrop);
      this.openDrawer = false;
      if (this.backdrop !== undefined) {
          this.backdrop.emit();
      }
    }
  }
}
